import dayjs from "dayjs";
import { createStore } from "zustand";
import { devtools } from "zustand/middleware";

import { URL_SEARCH_PARAMS } from "@/constants/urlSearchParams";

import { TDateRangeFilterState, TDateRangeProps } from "./DateRangeFilter.types";

const fromDateSearch = new URLSearchParams(location.search).get(URL_SEARCH_PARAMS.FROM_DATE);
const toDateSearch = new URLSearchParams(location.search).get(URL_SEARCH_PARAMS.TO_DATE);

export const createDateRangeFilterStore = (initProps?: Partial<TDateRangeProps>) => {
  const DEFAULT_PROPS: TDateRangeProps = {
    fromDate: fromDateSearch
      ? dayjs(fromDateSearch)
      : dayjs().startOf("month")
        .subtract(5, "month"),
    toDate: toDateSearch
      ? dayjs(toDateSearch)
      : dayjs().endOf("month"),
  };
  return createStore<TDateRangeFilterState>()(
    devtools(set => ({
      ...DEFAULT_PROPS,
      ...initProps,
      setDateRange: (dateRange: TDateRangeProps) => {
        set({
          fromDate: dateRange.fromDate,
          toDate: dateRange.toDate,
        });
      },
    })),
  );
};
